






















































































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';
import PrettyCheck from 'pretty-checkbox-vue/check';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonDropzoneWithAxios from '@/components/Dropzone/CommonDropzoneWithAxios.vue';

import {
  newProduct,
  getProduct,
  updateProduct,
  deleteProductImage,
} from '@/api/index';

import useAxios from '@/useAxios';
import useStoreProduct from '@/useStoreProduct';

const PanelWithProductEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    PrettyCheck,
    CommonDropzoneWithAxios,
  },
  props: {
    edit: { default() { return false; } },
  },
  setup(props: any) {
    const { route, router } = useRouter();
    const { axios } = useAxios();
    const { getValidUrl } = useStoreProduct();

    const successModal = ref(null);
    const loading = ref(true);

    const form = reactive({
      name: '',
      redirect_url: '',
      image: '',
      description: '',
      active: true,
      favorite: false,
      order: 0,
      price: 0,
      call: async () => {
        /* eslint-disable */
        if (props.edit === true) {
          await updateProduct(route.value.params.productId, {
            name: form.name,
            description: form.description,
            redirect_url: getValidUrl(form.redirect_url),
            image: form.image,
            active: form.active,
            favorite: form.favorite,
            order: form.order,
            price: form.price,
          });
          /* eslint-enable */
          (successModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
        } else {
          const result = await newProduct({
            name: form.name,
            image: form.image,
            description: form.description,
            active: form.active,
            favorite: form.favorite,
            store_id: route.value.params.id,
            redirect_url: getValidUrl(form.redirect_url),
            order: form.order,
            price: form.price,
          });
          router.push({
            name: 'StoreProductEdit',
            params: { productId: result.id },
          });
        }
      },
      state: {
        value: 'READY',
      },
    });

    async function callGetProduct() {
      const result = (await getProduct(route.value.params.id, route.value.params.productId)).data;
      form.name = result.name;
      form.description = result.description;
      form.redirect_url = result.redirect_url;
      form.active = result.active;
      form.favorite = result.favorite;
      form.image = result.image;
      form.order = result.order;
      form.price = result.price;
    }

    onMounted(async () => {
      if (props.edit === true) {
        await callGetProduct();
      }
      loading.value = false;
    });
    function handleUploadDone(data: any) {
      if (props.edit) form.image = data.image;
      else form.image = data.image;
    }

    const deleteImageModal = ref(null);
    async function deleteImageAction(ctx: { id: any }) {
      await deleteProductImage(ctx.id);
      await callGetProduct();
    }
    const openDeleteImageModal = (id: number) => {
      (deleteImageModal.value as any).compose({ id, action: 'ลบ', entity: 'รูปภาพ' });
    };

    return {
      successModal,
      form,
      axios,
      handleUploadDone,

      deleteImageModal,
      deleteImageAction,
      openDeleteImageModal,
    };
  },
});

export default PanelWithProductEditor;
